import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { mergeMap, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppState } from '../../app.state';
import { Route, RoutingHelperService } from '../services/routing-helper.service';

/**
 * Guarda só o Pagamento agora.
 *
 * Desde a inversão (23/10/2026), a inscrição nasce depois da assinatura do
 * contrato (`Contract.Enrolled`, em `app.state.ts`), não mais no fim do
 * passo de Dados — Dependentes e Contrato deixaram de exigi-la, porque é
 * exatamente a jornada de criar o contrato sem ela ainda existir. Só o
 * Pagamento continua precisando: `payments/create`/PIX/boleto pressupõem
 * uma inscrição já criada, e chegar aqui sem ela significa que a assinatura
 * (ou a inscrição que vem depois dela) ainda não aconteceu.
 */
export const subscriptionGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const routingService = inject(RoutingHelperService);

  return store.select(AppState.getSubscription).pipe(
    mergeMap((subscription) => {
      if (subscription) {
        return of(true);
      }

      router.navigate([routingService.getRelativePath(Route.Plans.path)]);
      return of(false);
    }),
    catchError(() => {
      router.navigate([routingService.getRelativePath(Route.Plans.path)]);
      return of(false);
    }),
  );
};
